'use strict'

export const lazyload = (() => {
    const setData = (item) => {
        if (item.dataset.src) {
            item.src = item.dataset.src
            delete item.dataset.src

            const picture = item.closest('picture')

            if (!picture) {
                return
            }

            const sources = picture.querySelectorAll('source[data-srcset]')

            sources.forEach((source) => {
                source.srcset = source.dataset.srcset
                delete source.dataset.srcset
            })
        }
    }

    const init = () => {
        const _images = document.querySelectorAll('[data-src]')

        _images.forEach((_item) => {
            // Ignore for UX performance
            const parentSlide = _item.closest('.splide__slide')
            const parentOverview = _item.closest('#attracties-overview')
            const hero = _item.closest('.hero')

            if (parentSlide || parentOverview || hero) {
                setData(_item)
            } else if ('IntersectionObserver' in window) {
                const _lazyloadObserver = new IntersectionObserver(
                    (entries, observer) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                const _item = entry.target
                                setData(_item)
                                observer.unobserve(_item)
                            }
                        })
                    },
                    {
                        // Start loading when image is 50% of the viewport height away
                        rootMargin: '50% 0px'
                    }
                )
                _lazyloadObserver.observe(_item)
            } else {
                // If browser doesn't support IntersectionObserver just copy data-src to src
                setData(_item)
            }
        })
    }

    return {
        init
    }
})()
